import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
  Legend,
} from 'recharts'

export default function CostBreakdownChart({
  baseCost,
  generalDuty,
  sec232 = 0,
  sec301 = 0,
  transshipment = 0,
  landedCost,
}) {
  const data = [
    { name: 'Base Cost', amount: baseCost, type: 'base' },
    { name: 'General Duty', amount: generalDuty, type: 'tariff' },
  ]

  if (sec232 > 0) {
    data.push({ name: 'Sec 232', amount: sec232, type: 'tariff' })
  }

  if (sec301 > 0) {
    data.push({ name: 'Sec 301', amount: sec301, type: 'penalty' })
  }

  if (transshipment > 0) {
    data.push({ name: 'Transshipment', amount: transshipment, type: 'penalty' })
  }

  data.push({ name: 'Landed Cost', amount: landedCost, type: 'total' })

  const getBarColor = (type) => {
    switch (type) {
      case 'base':
        return '#6b7280' // gray
      case 'tariff':
        return '#1e5045' 
      case 'penalty':
        return '#ef4444' // red
      case 'total':
        return '#f26522' 
      default:
        return '#94a3b8'
    }
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value)
  }

  return (
    <div className="w-full h-64">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 5, right: 30, left: 80, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} />
          <XAxis
            type="number"
            tickFormatter={formatCurrency}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            type="category"
            dataKey="name"
            axisLine={false}
            tickLine={false}
            width={75}
          />
          <Tooltip
            formatter={(value) => [formatCurrency(value), 'Amount']}
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
            }}
          />
          <Bar dataKey="amount" radius={[0, 4, 4, 0]}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={getBarColor(entry.type)} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
